import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
export const dispatch_OnProtocolInteraction = new ThunderDispatcher('__onProtocolInteraction');
//# sourceMappingURL=dispatcher.js.map